import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 部屋 API 操作クラス
 */
export default class NationalHolidays {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET NationalHolidays
   */
  public async gets(userStore: LoginUser): Promise<Array<NationalHolidaysGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.NationalHolidays, formatParams);
    const response = await this.commonService.executeGet<Array<NationalHolidaysGetModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface NationalHolidaysGetModel {
  /** 日付文字列(yyyy/mm/dd) */
  date: string;
  /** 日付数値(yyyymmdd000000000) */
  dateNum: number;
  /** 祝日名 */
  name: string;
}
